import plateBackground from './plate-background';
import plateHover from './plate-hover';
import plateSelected from './plate-selected';
import line from './line';
import arrows from './arrows';
import monthName from './month-name';
import weekDays from './week-days';
import dates from './dates';

export default {
  plateBackground,
  plateHover,
  plateSelected,
  line,
  arrows,
  monthName,
  weekDays,
  dates,
};
